import SectionHeading from "@/components/base/SectionHeading";
import { aboutHighlights } from "@/mocks/home";

export default function About() {
  return (
    <section id="about" className="bg-background-50 py-20 md:py-28">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 lg:px-10">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-16">
          <div className="reveal relative">
            <div className="overflow-hidden rounded-xl border border-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20green%20steel%20plant%20interior%20with%20clean%20electric%20arc%20furnace%2C%20emerald%20lighting%2C%20spotless%20industrial%20architecture%2C%20engineers%20reviewing%20holographic%20emissions%20data%2C%20artistic%20industrial%20photography%2C%20high%20detail&width=1000&height=1200&seq=gs-about-plant&orientation=portrait"
                alt="Inside the DJT EV Power Tech green steel plant"
                title="DJT EV Power Tech sustainable green steel production floor"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -right-2 hidden w-56 rounded-lg border border-background-200 bg-background-50 p-5 sm:block lg:-right-6">
              <div className="flex items-center gap-2 text-accent-600">
                <i className="ri-award-line text-2xl" />
                <span className="font-heading text-sm font-semibold text-foreground-950">
                  Andhra Pradesh · India
                </span>
              </div>
              <p className="mt-2 text-xs leading-relaxed text-foreground-500">
                Aligned with India's National Green Hydrogen Mission for steel.
              </p>
            </div>
          </div>

          <div>
            <SectionHeading
              eyebrow="Who we are"
              title="About DJT EV Power Tech"
              description="An Andhra Pradesh-based company focused on sustainable energy and green steel. Our goal is to build an integrated plant where renewable electricity produces green hydrogen, and that hydrogen turns iron ore into low-carbon iron."
            />

            <div className="mt-8 space-y-5">
              {aboutHighlights.map((item, index) => (
                <div
                  key={item.title}
                  className="reveal flex gap-4"
                  style={{ transitionDelay: `${index * 80}ms` }}
                >
                  <span className="flex h-11 w-11 flex-none items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                    <i className={`${item.icon} text-xl`} />
                  </span>
                  <div>
                    <h3 className="font-heading text-base font-semibold text-foreground-950">{item.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-600">{item.text}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="reveal mt-9 flex flex-wrap gap-3">
              <a
                href="#numbers"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                See the pilot numbers
                <i className="ri-arrow-right-line" />
              </a>
              <a
                href="#contact"
                className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
              >
                Book a plant tour
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}